import { render, staticRenderFns } from "./XkSvgIcon.vue?vue&type=template&id=319c6682&scoped=true&"
import script from "./XkSvgIcon.vue?vue&type=script&lang=js&"
export * from "./XkSvgIcon.vue?vue&type=script&lang=js&"
import style0 from "./XkSvgIcon.vue?vue&type=style&index=0&id=319c6682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319c6682",
  null
  
)

export default component.exports